import { EventEmitter } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './../i18n/en.json';
import spanish from './../i18n/es.json';
import portuguese from './../i18n/pt.json';
var IndicationPopUpComponent = /** @class */ (function () {
    function IndicationPopUpComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.popUpClosed = new EventEmitter();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    IndicationPopUpComponent.prototype.closePopup = function () {
        this.popUpClosed.emit();
    };
    return IndicationPopUpComponent;
}());
export { IndicationPopUpComponent };
